import { render, staticRenderFns } from "./BookingCustomerCreate.vue?vue&type=template&id=fbd52b8e&scoped=true"
import script from "./BookingCustomerCreate.vue?vue&type=script&lang=js"
export * from "./BookingCustomerCreate.vue?vue&type=script&lang=js"
import style0 from "./BookingCustomerCreate.vue?vue&type=style&index=0&id=fbd52b8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd52b8e",
  null
  
)

export default component.exports